'use strict';

var REPEAT_INDEFINITELY = 0;
var ALWAYS_RUN_ANGULAR_APPLY = true;

angular.module('amexReconciliationApp')
  .service('SessionTimeoutService', function SessionTimeoutService($window, $interval, $q, $rootScope) {
    var self = this;
    var SESSION_TIMEOUT_WARNING = 'session_timeout_warning';

    var sessionTimeoutLength = 30 * 60 * 1000;
    var modalWarningLength = 15 * 1000;
    self.warningCountdownLength = 5 * 60 * 1000;

    self.getRemainingTime = function getRemainingTime () {
      return $window.REMAINING_TIME;
    };

    self.resetRemainingTime = function resetRemainingTime () {
      $window.REMAINING_TIME = sessionTimeoutLength;
    };

    self.onTimeoutWarning = function onTimeoutWarning (scope, handler) {
      scope.$on(SESSION_TIMEOUT_WARNING, handler);
    };

    function decrementRemainingTime () {
      $window.REMAINING_TIME -= 1000;
    }

    self.resetRemainingTime();

    function timeoutServiceInterval() {
      decrementRemainingTime();

      if (self.getRemainingTime() === modalWarningLength) {
        $rootScope.$broadcast(SESSION_TIMEOUT_WARNING);
      }

      if (self.getRemainingTime() <= 0) {
        $window.location ='/logout';
      }
    }

    $interval(timeoutServiceInterval, 1000, REPEAT_INDEFINITELY, ALWAYS_RUN_ANGULAR_APPLY);
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/SessionTimeoutService.js
// module id = 647
// module chunks = 0